import { defineStore } from 'pinia'

import { actions } from './actions'
import { createInitialState } from './state'
import { getters } from './getters'

export const useKidStore = defineStore('kid', {
  state: createInitialState,
  actions,
  getters,
})
